import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { customerActions } from '../../modules/Actions';

export interface OptinMailState {
  mailPermissionType: string;
}

export const initialState: OptinMailState = {
  mailPermissionType: '',
};

export const OptinMailReducer = reducerWithInitialState(initialState).case(
  customerActions.updateMailPermissionType,
  (state: OptinMailState, payload: OptinMailState) => {
    return payload;
  }
);
